import React from "react";
import MultipleChoiceAnswer from "./MultipleChoiceAnswer";
import CheckboxAnswer from "./CheckboxAnswer";
import ScaleAnswer from "./ScaleAnswer";
import FileAnswer from "./FileAnswer";

const QuizQuestionItem = ({
  spinner,
  disabled,
  question,
  questions,
  setAnswer,
  user_answers,
  handleSave,
}) => {
  const isUnsaved = () =>
    user_answers.find(
      ({ question_id, user_answer_id }) =>
        question_id === question.question_id && !user_answer_id
    );

  const renderAnswers = () => {
    switch (question.type) {
      case "scale":
        return (
          <ScaleAnswer
            question={question}
            setAnswer={setAnswer}
            user_answers={user_answers}
          />
        );
      case "multiple":
        return question.answers.map((answer) => (
          <MultipleChoiceAnswer
            user_answers={user_answers}
            key={answer.answer_id}
            setAnswer={setAnswer}
            question={question}
            answer={answer}
          />
        ));
      case "checkbox":
        return question.answers.map((answer) => (
          <CheckboxAnswer
            user_answers={user_answers}
            key={answer.answer_id}
            setAnswer={setAnswer}
            question={question}
            answer={answer}
          />
        ));
      case "file":
        return (
          <FileAnswer
            user_answers={user_answers}
            setAnswer={setAnswer}
            question={question}
          />
        );
      default:
        return (
          <div>
            <label>Escribe tu respuesta</label>
            <input
              type="text"
              className="form-control"
              defaultValue={
                user_answers.find(
                  ({ question_id }) => question_id === question.question_id
                )?.content ?? ""
              }
              onChange={(e) => {
                setAnswer(question.question_id, e.target.value);
              }}
            />
          </div>
        );
    }
  };

  return (
    <div className="mb-5" id={`question-${question.order}`}>
      <div className="text-primary">
        Pregunta {question.order} de {questions.length}
      </div>
      <div className="p-3 bg-light">{question.content}</div>
      <div className="mt-3">{renderAnswers()}</div>
      {isUnsaved() && (
        <button
          disabled={disabled || spinner}
          onClick={() => handleSave(question)}
          className="btn btn-accent btn-sm mt-3"
        >
          {spinner ? <div className="spinner-border"></div> : "Guardar"}
        </button>
      )}
    </div>
  );
};

export default QuizQuestionItem;
